import { pluralizeCopy } from "./copy";

export const getRemoveFeatureGroupConfirm = ({ title, featureCount }) => {
  const prefix = `Are you sure you want to remove ${title}`;
  const suffix = featureCount
    ? ` and it's ${pluralizeCopy("feature", featureCount)}`
    : "";
  return [prefix, suffix, "?"].join("");
};
